module.exports = __webpack_public_path__ + "img/certified-doctors-only.0328c1e9.jpg";